import ContentLoader from 'react-content-loader';

const padding = 8;
const height = 30;

function getRandomInt(min: number, max: number) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //최댓값은 제외, 최솟값은 포함
}

export const StockTableLoader = () => {
  return (
    <ContentLoader viewBox={`0 0 261 228`}>
      {Array.from({ length: getRandomInt(3, 6) }).map((_, i) => (
        <rect key={i} x={0} y={i * (height + padding)} rx={4} ry={4} width={261} height={height} />
      ))}
    </ContentLoader>
  )
}
